export default "__VITE_ASSET__Cl$Ret2B__"